import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { CargoApiService } from 'app/api/cargoApi.service';
import { UsuariosService } from 'app/api/usuarios.service';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { PessoaJuridica } from 'app/model/pessoaJuridica';
import { User } from 'app/model/user';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-cargos-clonar',
  templateUrl: './cargos-clonar.component.html',
  styleUrls: ['./cargos-clonar.component.css']
})
export class CargosClonarComponent implements OnInit, OnDestroy {

  clientes$: Observable<PessoaJuridica[]>;
  usuarioLogado$: Observable<User>;
  usuarioLogadoPj: number;
  @Input() idCargo: number;
  @Input() tipoCargo: string;
  @Input() titulo: number;
  @Input() pessoaJuridicaId: number;
  @Input() nivel: string;
  @Input() descricao: string;
  @Input() area: string;
  // @Output() updateLista = new EventEmitter();
  @Output() updateLista = new EventEmitter<{ id: number; tipoCargo: string }>();
  @Output() closeModal = new EventEmitter();
  addForm: FormGroup;
  submitted = false;
  incluirAvaliacao = false;

  private subs = new SubSink();

  constructor(
    private cargosService: CargoApiService,
    private clientesService: ClienteApiService,
    private usuariosService: UsuariosService,
    private formBuilder: FormBuilder,
    private location: Location,
    private alertService: AlertModalService
  ) {
    this.addForm = this.formBuilder.group({
      novoTitulo: ['', Validators.required],
      novaDescricao: null,
      novaArea: null,
      novoNivel: null,
      novoTipoCargo: null, 
      novoCodigoReferencia: null, 
      incluirAvaliacoesAssociadas: null,
      incluirPerfisAssociados: null,
      incluirWebhooks: null,
      pessoaJuridicaId: this.pessoaJuridicaId,
    });
  }

  ngOnInit() {
    this.loadForm();
    this.getClientes();
    this.usuarioLogado$ = this.usuariosService.v1UsuariosLogadoGet().pipe(share());
    this.usuarioLogado$.forEach(usuarioLogado => { this.usuarioLogadoPj = usuarioLogado.pessoaJuridicaId })
  }

  loadForm() {
    this.addForm.setValue({
      novoTitulo: this.titulo,
      novaDescricao: this.descricao,
      novaArea: this.area,
      novoNivel: this.nivel,
      novoTipoCargo: null, 
      novoCodigoReferencia: null, 
      incluirAvaliacoesAssociadas: null,
      incluirPerfisAssociados: null,
      incluirWebhooks: null,
      pessoaJuridicaId: this.pessoaJuridicaId,
    });
  }

  get f() { return this.addForm.controls; }

  clonarCargo(): void {

    this.submitted = true;
    if (this.addForm.invalid) { return; }

    const novoTitulo = this.addForm.value.novoTitulo;
    const novaDescricao = this.addForm.value.novaDescricao;
    const novaArea = this.addForm.value.novaArea;
    const novoNivel = this.addForm.value.novoNivel;
    const novoTipoCargo = this.addForm.value.novoTipoCargo ? 'Normal' : 'Modelo';
    const novoCodigoReferencia = null;
    // const incluirAvaliacoesAssociadas = this.addForm.value.incluirAvaliacoesAssociadas;
    const incluirAvaliacoesAssociadas = this.addForm.value.novoTipoCargo ? this.addForm.value.incluirAvaliacoesAssociadas : null; // Se a opção for por cargo Modelo não é possível associar avaliações.
    const incluirPerfisAssociados = this.addForm.value.incluirPerfisAssociados;
    const incluirWebhooks = null;
    let novaPessoaJuridicaId: number;
    if (this.usuarioLogadoPj === null) {
      novaPessoaJuridicaId = this.pessoaJuridicaId;
    } else {
      novaPessoaJuridicaId = this.usuarioLogadoPj;
    }
    if (this.addForm.value.pessoaJuridicaId) {
      novaPessoaJuridicaId = this.addForm.value.pessoaJuridicaId;
    } 

    this.subs.sink = this.cargosService.v1CargoCargoIdDuplicarPost(
      this.idCargo,
      novoTitulo,
      novaDescricao,
      novaArea,
      novoNivel,
      novoTipoCargo, 
      novoCodigoReferencia, 
      incluirAvaliacoesAssociadas,
      incluirPerfisAssociados,
      incluirWebhooks, 
      novaPessoaJuridicaId)
    .subscribe(success => {
      this.alertService.showAlertSuccess('Cargo clonado com sucesso!');
      // this.updateLista.emit(success.id);
      this.updateLista.emit({ id: success.id, tipoCargo: success.tipoCargo });
      this.closeModal.emit();
    }, error => {
      console.error("Erro:", error);
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger('Erro ao clonar Cargo. Tente mais tarde.');
      }
    });
  }

  // As funções onChangeIncluirAvaliacao(event) e onChangeTipoCargo(event)
  // restringem a associação de avaliações a apenas Cargos Normais
  // Cargos Modelo não podem receber associação de avaliações
  onChangeIncluirAvaliacao(event) {
    const novoTipoCargoControl = this.addForm.get('novoTipoCargo');
    if(event.target.checked) {
      novoTipoCargoControl.setValue(true);
      this.incluirAvaliacao = true;
    } else {
      this.incluirAvaliacao = false;
    }
  }

  onChangeTipoCargo(event) {
    const novoIncluirAvaliacaoControl = this.addForm.get('incluirAvaliacoesAssociadas');
    if(!event.target.checked && this.incluirAvaliacao) {
      novoIncluirAvaliacaoControl.setValue(false);
    } 
  }

  private getClientes() {
    this.clientes$ = this.clientesService.v1ClienteGet();
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
